module.exports = __webpack_public_path__ + "img/look_active.9b4c7ded.svg";